import { Button, ColumnDef, Row, useTheme } from "@commonlibs";
import type { PartnerPointsOfSellKpisDto } from "common/models/api/models/PartnerPointsOfSellKpisDto";
import { useNavigate } from "react-router-dom";
import useIsMobile from "ui/common/hooks/useIsMobile";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import Balance from "ui/wallet/component/display/Balance/Balance";
import PointsBalance from "ui/wallet/containers/PointsBalance/PointsBalance";
import { PARTNER_POINT_OF_SELL_COLUMNS } from "./usePartnerPointOfSellColumns.types";

export function usePartnerPointOfSellColumns(): ColumnDef<PartnerPointsOfSellKpisDto>[] {
    const translate = useTranslate();
    const isMobile = useIsMobile();
    const { spacing } = useTheme();
    const navigate = useNavigate();

    return [
        {
            accessorKey: PARTNER_POINT_OF_SELL_COLUMNS.REDEEM,
            header: translate("totalRedeemedKPI"),
            size: isMobile ? 100 : 120,
            cell: (info) => info.getValue(),
            accessorFn: (row) => <PointsBalance balance={row.totalRedeemed} variant="body2Regular" />,
        },
        {
            accessorKey: PARTNER_POINT_OF_SELL_COLUMNS.TRANSACTIONS,
            size: isMobile ? 100 : 120,
            header: translate("totalTransactions"),
            cell: (info) => info.getValue(),
            accessorFn: (row) => <Balance balance={String(row.totalTransactions)} variant="body2Regular" />,
        },
        {
            accessorKey: PARTNER_POINT_OF_SELL_COLUMNS.AMOUNT,
            size: isMobile ? 100 : 120,
            header: translate("totalAmount"),
            cell: (info) => info.getValue(),
            accessorFn: (row) => <PointsBalance balance={String(row.totalAmount)} variant="body2Regular" />,
        },
        {
            accessorKey: PARTNER_POINT_OF_SELL_COLUMNS.ACTIONS,
            size: isMobile ? 100 : 120,
            header: "",
            cell: (info) => info.getValue(),
            accessorFn: (row) => (
                <Row gap={spacing[4]} justifyContent="flex-end" style={{ padding: spacing[4] }} wrap wrapGap={spacing[4]}>
                    <Button size="md" variant={"primary"} onClick={() => navigate(`${MainRoutes.TRANSACTIONS}?query=${row.address}`)}>
                        {translate("viewTransactions")}
                    </Button>
                </Row>
            ),
        },
    ];
}
